import React from 'react';
import type {NativeStackScreenProps} from '@react-navigation/native-stack';
import {useTranslation} from 'react-i18next';

import type {SettingsStackParamList} from '@/app/routes';
import {useAuthStore} from '@/entities/session/auth-store';
import {CalendarList} from '@/features/manage-calendar/ui/CalendarList';
import {Page} from '@/shared/ui/page';
import {SettingsNav} from '@/pages/settings/SettingsNav';

/**
 * «Настройки» → «Праздники и выходные» (SV-54): календарь всей компании.
 * Отдельные даты отдела правятся на экране отдела — там же видно, что пришло
 * от компании.
 */
type Props = NativeStackScreenProps<SettingsStackParamList, 'CalendarSettings'>;

export function CalendarSettingsScreen(_: Props) {
  const {t} = useTranslation();
  const companyId = useAuthStore(s => s.activeContext?.companyId);

  return (
    <Page
      sideNav={<SettingsNav />}
      width="form"
      scroll
      testID="calendar-settings"
      title={t('calendar.title')}
      subtitle={t('calendar.subtitle')}>
      {companyId ? <CalendarList companyId={companyId} /> : null}
    </Page>
  );
}
